The optional hirer associated with this webhook subscription.

This will only be accessible if there is an active relationship between the partner and hirer.

By default webhook subscriptions will send events from all hirers the partner has access to.
A non-null `hirer` field indicates that this subscription is filtered to a single hirer.
